<template>
  <div
    class="tw-mb-4 tw-w-full tw-grid tw-gap-3 xs:tw-gap-5"
    :class="[
      Classes.GAME_TILE_GRID,
      filterOpen
        ? 'tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 2xl:tw-grid-cols-5'
        : 'tw-grid-cols-2 sm:tw-grid-cols-3 lg:tw-grid-cols-4 xl:tw-grid-cols-5 2xl:tw-grid-cols-6',
    ]"
  >
    <slot />
  </div>
</template>

<script>
import Classes from '@shared/js/config/css.js'
export default {
  props: {
    filterOpen: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    return {
      Classes,
    }
  },
}
</script>
